import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { checkRole, makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// ROUTES
import AMFinance from './settings/AMFinance';
import CustomerRebates from './settings/CustomerRebates';
import DealerForms from './settings/DealerForms';
import DealerIncentives from './settings/DealerIncentives';
import InventoryPacks from './settings/InventoryPacks';
import DealPacks from './settings/DealPacks';
import DealerSettings from './settings/DealerSettings';
import DynamicForms from './settings/DynamicForms';
import EmailSettings from './settings/EmailSettings';
import Reports from './settings/Reports';
import SpotInstructions from './settings/SpotInstructions';
import Vendors from './settings/Vendors';
import Staff from './settings/Staff';
import Users from './settings/Users';

// MAIN COMPONENT
const Settings = () => (
  <Routes>
    {checkRole(['dslAdmin']) && [
      <Route
        key={SETTINGS.amFinance}
        path={makePath(SETTINGS.amFinance) + '*'}
        element={<AMFinance />}
      />,
      <Route
      key={SETTINGS.dealerSettings}
      path={makePath(SETTINGS.dealerSettings)}
      element={<DealerSettings />}
      />
    ]}
    <Route
      path={makePath(SETTINGS.emailSettings) + '*'}
      element={<EmailSettings />}
    />
    <Route
      path={makePath(SETTINGS.inventoryPacks) + '*'}
      element={<InventoryPacks />}
    />
    <Route
      path={makePath(SETTINGS.dealPacks) + '*'}
      element={<DealPacks />}
    />
    <Route
      path={makePath(SETTINGS.customerRebates) + '*'}
      element={<CustomerRebates />}
    />
    {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus']) &&
      <Route
        path={makePath(SETTINGS.dealerForms) + '*'}
        element={<DealerForms />}
      />
    }
    <Route
      path={makePath(SETTINGS.dealerIncentives) + '*'}
      element={<DealerIncentives />}
    />
    {checkRole(['dslAdmin']) && [
      <Route
        key={SETTINGS.spotInstructions}
        path={makePath(SETTINGS.spotInstructions) + '*'}
        element={<SpotInstructions />}
      />,
      <Route
        key={SETTINGS.reports}
        path={makePath(SETTINGS.reports) + '*'}
        element={<Reports />}
      />,
      <Route
        key={SETTINGS.dynamicForms}
        path={makePath(SETTINGS.dynamicForms)}
        element={<DynamicForms />}
      />
    ]},
    {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus']) && <Route
      key={SETTINGS.vendors}
      path={makePath(SETTINGS.vendors) + '*'}
      element={<Vendors />}
    />},
    {checkRole(['dslAdmin']) && [
      <Route
        key={SETTINGS.staff}
        path={makePath(SETTINGS.staff)}
        element={<Staff />}
      />,
      <Route
        key={SETTINGS.users}
        path={makePath(SETTINGS.users)}
        element={<Users />}
      />
    ]}
    <Route path="*" element={<Navigate to={makePath(INTERFACE.dailySales)} replace />} />
  </Routes>
)

// EXPORT
export default Settings;
